import Vue from 'vue';
import VueI18n from 'vue-i18n';
import Promise from 'promise';
import defaultMessage from './lang/zh-CN';
import elementDefailtMessage from 'element-ui/lib/locale/lang/zh-CN';
import ls from '@/utils/local-storage';

Vue.use(VueI18n);

// 语言代码参考：http://www.w3school.com.cn/tags/html_ref_language_codes.asp

// 目前支持的语言
export const languages = [
    {lang: 'zh-CN', text: '中文'},
    {lang: 'en', text: 'English'}
];

// 预装默认语言
export const defaultLang = 'zh-CN';
const loadedLanguages = [defaultLang];
document.querySelector('html').setAttribute('lang', defaultLang);

export const i18n = new VueI18n({
    locale: defaultLang, // 设置语言环境
    fallbackLocale: defaultLang, // 设置回退语言
    messages: { // 设置语言环境信息
        [defaultLang]: {
            ...defaultMessage,
            // 混入element-ui语言包
            ...elementDefailtMessage
        }
    }
});

// 异步加载语言
export function loadLanguageAsync (lang) {
    if (i18n.locale !== lang) {
        if (!loadedLanguages.includes(lang)) {
            return Promise.all([
                // 我们自己的语言包
                import(/* webpackChunkName: "lang-[request]" */ `@/locale/lang/${lang}`),
                // element-ui语言包
                import(`element-ui/lib/locale/lang/${lang}`)
            ]).then(msgs => {
                i18n.setLocaleMessage(lang, {
                    ...msgs[0].default,
                    ...msgs[1].default
                });
                loadedLanguages.push(lang);
                return setI18nLanguage(lang);
            });
        }
        return Promise.resolve(setI18nLanguage(lang));
    }
    return Promise.resolve(lang);
}

export function setI18nLanguage (lang) {
    // 设置全局i18n中的locale属性
    i18n.locale = lang;
    // 修改http header
    Vue.http.headers.common['Accept-Language'] = lang;
    // 本地存储选中的lang
    ls.set('lang', lang);
    // 设置html lang属性
    document.querySelector('html').setAttribute('lang', lang);
    return lang;
}
